var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocumentLibrary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Library_Icon",
    "data-name": "Library Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5780",
    "data-name": "Path 5780",
    d: "M194.966,168.983a.285.285,0,0,0-.285.285v9.121a25.857,25.857,0,0,0-5.594.358,11.133,11.133,0,0,1,4.737-.916.285.285,0,0,0,.285-.285v-9.135a.285.285,0,0,0-.285-.285,11.233,11.233,0,0,0-6.28,1.664,11.235,11.235,0,0,0-6.28-1.664.285.285,0,0,0-.285.285v9.135a.285.285,0,0,0,.285.285,11.133,11.133,0,0,1,4.737.916,25.835,25.835,0,0,0-5.594-.358v-9.121a.285.285,0,0,0-.571,0v9.42a.286.286,0,0,0,.089.207.294.294,0,0,0,.212.078c.051,0,5.088-.269,7.278.827a.239.239,0,0,0,.034.012l.023.008a.283.283,0,0,0,.071.01h0a.275.275,0,0,0,.071-.01l.022-.008a.235.235,0,0,0,.034-.012c2.189-1.095,7.228-.83,7.278-.827a.293.293,0,0,0,.212-.078.285.285,0,0,0,.089-.207v-9.42A.286.286,0,0,0,194.966,168.983Zm-1.427,8.28a11.13,11.13,0,0,0-5.709,1.489v-8.47a10.569,10.569,0,0,1,5.709-1.583ZM181.55,168.7a10.568,10.568,0,0,1,5.709,1.583v8.47a11.13,11.13,0,0,0-5.709-1.489Z",
    transform: "translate(-179.837 -166.127)",
    fill: "#1a1818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentLibrary);
export default __webpack_public_path__ + "static/media/icon_document_library.5263f442a81375da8c8f2fc1995cc35f.svg";
export { ForwardRef as ReactComponent };